export default __webpack_public_path__ + "static/media/project-socialmedia.ea074de0.PNG";